import { render, staticRenderFns } from "./RevisionHistory.vue?vue&type=template&id=374be6ba"
import script from "./RevisionHistory.vue?vue&type=script&lang=js"
export * from "./RevisionHistory.vue?vue&type=script&lang=js"
import style0 from "./RevisionHistory.vue?vue&type=style&index=0&id=374be6ba&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports